"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FavoritesButton", {
  enumerable: true,
  get: function () {
    return _FavoritesButton.FavoritesButton;
  }
});
var _FavoritesButton = require("./components/FavoritesButton");